import { LoadableLazy } from '@confluence/loadable';

export { preloadRecentPages } from './preloadRecentPages';

export const RecentPagesLazy = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RecentPagesRecentPages" */ './RecentPages'))
			.RecentPages,
});
